<ng-template #nodeTemplateRef let-value>
  <ng-container *ngIf="isObject(value.value)">
    <li>
      {{ value.label }}
      <ul class="powerlist-list">
        <ng-container
          *ngFor="let item of value.value | keyvalue"
          [ngTemplateOutlet]="nodeTemplateRef"
          [ngTemplateOutletContext]="{ $implicit: item.value }"
        >
        </ng-container>
      </ul>
    </li>
  </ng-container>
  <ng-container *ngIf="!isObject(value.value)">
    <li class="powerlist-item" [attr.data-value]="value.value">
      {{ value.label }}
    </li>
  </ng-container>
</ng-template>

<div class="nav-container">
  <nav [class.readonly]="disabled" class="powerlistmenu" #powerlist>
    <ul class="powerlist-list">
      <ng-container
        *ngFor="let item of parsedMenuItems | keyvalue"
        [ngTemplateOutlet]="nodeTemplateRef"
        [ngTemplateOutletContext]="{ $implicit: item.value }"
      >
      </ng-container>
    </ul>
  </nav>
</div>
